// DepartmentMaster.jsx
import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { Table, PageHeader, Modal, FormField, ConfirmDialog } from '../../../components/UI';
import toast from 'react-hot-toast';

const emptyDept = { dept_name:'', dept_code:'', dept_type:'related', description:'', is_active:1 };

export default function DepartmentMaster() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyDept);
  const [saving, setSaving] = useState(false);

  const load = () => { setLoading(true); api.get('/masters/departments').then(r => setItems(r.departments||[])).finally(()=>setLoading(false)); };
  useEffect(()=>{ load(); },[]);

  const openAdd = () => { setForm(emptyDept); setEditing(null); setModal(true); };
  const openEdit = (item) => { setForm({...item}); setEditing(item); setModal(true); };
  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await api.put(`/masters/departments/${editing.id}`, form); toast.success('Updated'); }
      else { await api.post('/masters/departments', form); toast.success('Created'); }
      setModal(false); load();
    } catch { toast.error('Save failed'); } finally { setSaving(false); }
  };

  const columns = [
    {key:'dept_code',label:'Code'},
    {key:'dept_name',label:'Department Name'},
    {key:'dept_type',label:'Type',render:r=><span className={`capitalize px-2 py-0.5 rounded text-xs font-medium ${r.dept_type==='final_approval'?'bg-blue-100 text-blue-700':'bg-green-100 text-green-700'}`}>{r.dept_type?.replace('_',' ')}</span>},
    {key:'is_active',label:'Status',render:r=><span className={r.is_active?'text-green-600':'text-red-500'}>{r.is_active?'Active':'Inactive'}</span>},
    {key:'actions',label:'Actions',render:r=><button onClick={()=>openEdit(r)} className="text-xs bg-yellow-50 text-yellow-600 border border-yellow-200 px-2 py-1 rounded">✏️ Edit</button>}
  ];

  return (
    <div>
      <PageHeader title="Department Master" subtitle="Manage departments" actions={<button className="btn-primary" onClick={openAdd}>+ Add Department</button>} />
      <div className="card overflow-hidden p-0"><Table columns={columns} data={items} loading={loading} /></div>
      <Modal isOpen={modal} onClose={()=>setModal(false)} title={editing?'Edit Department':'Add Department'}>
        <form onSubmit={handleSave} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Department Name" required><input className="form-input" value={form.dept_name} onChange={e=>f('dept_name',e.target.value)} required /></FormField>
            <FormField label="Department Code" required><input className="form-input" value={form.dept_code} onChange={e=>f('dept_code',e.target.value.toUpperCase())} required /></FormField>
            <FormField label="Department Type">
              <select className="form-select" value={form.dept_type} onChange={e=>f('dept_type',e.target.value)}>
                <option value="related">Related Department</option>
                <option value="final_approval">Final Approval</option>
                <option value="admin">Admin</option>
              </select>
            </FormField>
            <FormField label="Status">
              <select className="form-select" value={form.is_active} onChange={e=>f('is_active',e.target.value)}>
                <option value={1}>Active</option><option value={0}>Inactive</option>
              </select>
            </FormField>
          </div>
          <FormField label="Description"><textarea className="form-input" rows={2} value={form.description} onChange={e=>f('description',e.target.value)} /></FormField>
          <div className="flex gap-3 justify-end"><button type="button" className="btn-secondary" onClick={()=>setModal(false)}>Cancel</button><button type="submit" className="btn-primary" disabled={saving}>{saving?'Saving...':'Save'}</button></div>
        </form>
      </Modal>
    </div>
  );
}
